import { Estimate } from '../model/estimate/estimate.model'

/**
 * Map estimate status enum to translation keys.
 */
export function estimateStatusText(status?: Estimate.STATUS): string {
  switch (status) {
    case Estimate.STATUS.DRAFT:
      return 'statuses.estimate.draft'
    case Estimate.STATUS.CONFIRMED:
      return 'statuses.estimate.confirmed'
    case Estimate.STATUS.DELIVERED:
      return 'statuses.estimate.delivered'
    case Estimate.STATUS.UNDELIVERED:
      return 'statuses.estimate.undelivered'
    default:
      return 'statuses.estimate.unknown'
  }
}
